export function isUserRejectError(error) {
    const { code, message } = error;
    return code === 4001 || message?.toLowerCase().includes('user rejected');
}
//# sourceMappingURL=wallet-errors.js.map